// extracted by mini-css-extract-plugin
export var subtitle = "styles-module--subtitle--c24f3";
export var title = "styles-module--title--cc483";
export var wrapper = "styles-module--wrapper--c4b38";